import React,{useRef, useState, useEffect} from "react";
import { Button, Row, Col, Form} from "react-bootstrap";
import Select from "react-select";
import Rainbow from 'rainbowvis.js';
import ColorPicker from "../components/ColorPicker";
import { useContextMenu, contextMenu, Menu, Item } from 'react-contexify';

class PaletteSelector extends React.Component {

	
	static palettes = {
		sequential : [
			["#ff0000", "#000000"],
			["#ffc6c4", "#672044"],
			["#fde0c5", "#eb4a40"],
			["#fef6b5", "#e15383"],
			["#e4f1e1", "#0d585f"],
		],
		divergent : [
			
			["#798234", "#f5e5b5", "#d46780"],
			["#3d5941", "#ece5b6", "#ea562c"],
			["#008080", "#ece7ba", "#ca562c"],
			["#009392", "#fafcf9", "#cf5981"],
		]
	}
	
	constructor(props) {
		
		super(props);
		
		
		this.state = {
			type : 'sequential',
			reverse : false,
			show: this.props.show,
			position:{}
		};
	}


	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	handleReverse(e){

		e.preventDefault();
		e.stopPropagation();
		this.updateStatus({reverse:!this.state.reverse});
	}
	selectPalette(idx){
		
		if(PaletteSelector.palettes[this.state.type][idx]){
			const colorPoints = [...PaletteSelector.palettes[this.state.type][idx]];
			if(this.state.reverse)
				colorPoints.reverse();
			if(this.props.onSelect)
				this.props.onSelect(colorPoints);
		}
	}
	
	position(event){
		
		var parent = event.target.closest("div.opacity-panel").getBoundingClientRect();
		
		var overlay = {top:((parent.y*-1)+"px"), left:((parent.x*-1)+"px"), width:(window.innerWidth+'px'), height:(window.innerHeight+'px')};
		
		return {
			overlay:overlay, 
			menu:{
				top:(event.clientY+"px"), 
				left:(event.clientX+"px"),
				topY:event.clientY, 
				leftX:event.clientX
			}
		};
		
		
	}
	handleInsideClick(e){
		e.preventDefault();
		e.stopPropagation();
		
	}
	handleOutsideClick(e){
		e.preventDefault();
		e.stopPropagation();
		if(this.props.onClose)
			this.props.onClose();
		
	}
	componentDidMount() {
		
		var size = document.querySelector(".palette-selector").getBoundingClientRect();
		
		const position = this.position(this.props.show);
		
		if((size.height + size.top) > window.innerHeight)
			position.menu.top = (position.menu.topY-size.height)+"px";
		
		
		
		this.updateStatus({position:position});
		
	}
	render() {
		if(!this.state.show)
			return;
		const palettes = PaletteSelector.palettes[this.state.type];
		
		return (
			<div className="palette-selector-overlay" style={this.state.position.overlay} onClick={(e)=>{this.handleOutsideClick(e);}}>
				<div className="palette-selector" style={this.state.position.menu} onClick={(e)=>{this.handleInsideClick(e);}}>
					<Row className="reverse">
						<Col xs="12">
						 {
						 // somehow i have to put 2 checkboxes as it will not update state :\ weird}
						 }
							Reverse
							{this.state.reverse &&
							<Form.Check  type="switch"
								id="palette-reverse" 
								value={1} 
								onClick={(e)=>{this.handleReverse(e);}} 
								checked={this.state.reverse}
							/>
							}
							{!this.state.reverse &&
							<Form.Check  type="switch"
								id="palette-reverse" 
								value={1} 
								onClick={(e)=>{this.handleReverse(e);}} 
								checked={this.state.reverse}
							/>
							}
						</Col>
					</Row>
					<Row className={"select-type " + this.state.type}>
						<Col xs="6">
							<span className="seq" onClick={(e)=>{this.updateStatus({type:'sequential'})}}>Sequential</span>
						</Col>
						<Col xs="6">
							<span className="div" onClick={(e)=>{this.updateStatus({type:'divergent'})}}>Divergent</span>
						</Col>
					</Row>
					<Row className="gradients">
					{
						palettes.map((p, j)=>{

							var colors = new Rainbow();

							const colorPoints = [...p];

							if(this.state.reverse)
								colorPoints.reverse();

							colors.setSpectrum.apply(colors, colorPoints);
							colors.setNumberRange(0, 10);
							return (
								<Col xs="12" className="gradient p-0 mb-1">
									{
										[...Array(10).keys()].map((idx, k)=>{

											return (<div key={k} onClick={(e)=>{this.selectPalette(j);}} className="tile" style={{backgroundColor:"#"+colors.colourAt(idx)}}></div>);
										})
									}
								</Col>
							)
						})
					}
					</Row>
				</div>
		
			</div>
			
			
			
		);
			
		
	}
}

export default PaletteSelector;